/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommissionRateViewRespVo } from './CommissionRateViewRespVo';
import {
    CommissionRateViewRespVoFromJSON,
    CommissionRateViewRespVoFromJSONTyped,
    CommissionRateViewRespVoToJSON,
    CommissionRateViewRespVoToJSONTyped,
} from './CommissionRateViewRespVo';

/**
 * 
 * @export
 * @interface ResponseCommissionRateViewRespVo
 */
export interface ResponseCommissionRateViewRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseCommissionRateViewRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseCommissionRateViewRespVo
     */
    message?: string;
    /**
     * 
     * @type {CommissionRateViewRespVo}
     * @memberof ResponseCommissionRateViewRespVo
     */
    data?: CommissionRateViewRespVo;
}

/**
 * Check if a given object implements the ResponseCommissionRateViewRespVo interface.
 */
export function instanceOfResponseCommissionRateViewRespVo(value: object): value is ResponseCommissionRateViewRespVo {
    return true;
}

export function ResponseCommissionRateViewRespVoFromJSON(json: any): ResponseCommissionRateViewRespVo {
    return ResponseCommissionRateViewRespVoFromJSONTyped(json, false);
}

export function ResponseCommissionRateViewRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCommissionRateViewRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : CommissionRateViewRespVoFromJSON(json['data']),
    };
}

export function ResponseCommissionRateViewRespVoToJSON(json: any): ResponseCommissionRateViewRespVo {
    return ResponseCommissionRateViewRespVoToJSONTyped(json, false);
}

export function ResponseCommissionRateViewRespVoToJSONTyped(value?: ResponseCommissionRateViewRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': CommissionRateViewRespVoToJSON(value['data']),
    };
}

